<template>
  <div class="circle">
    <div class="plot" ref="container" />
  </div>
</template>

<script>
import { Donut } from '../../utils/plots';

export default {
  name: 'CircularProgressBar',
  props: {
    size: {
      type: Number,
      default: 10
    },
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      donut: null
    };
  },
  mounted () {
    this.donut = new Donut(this.$refs.container);
    this.donut.size = this.$props.size;
    this.donut.init();
    this.donut.setData([
      { color: '#c23633', value: this.$props.value },
      { color: '#333', value: this.$props.max - this.$props.value }
    ]);

    this.donut.start();
  },
  beforeDestroy () {
    this.donut.stop();
  },
  watch: {
    value (data) {
      this.update(data, this.$props.max);
    },
    max (data) {
      this.update(this.$props.value, data);
    },
    size (data) {
      this.donut.size = data;
      this.donut.draw();
    }
  },
  methods: {
    update (value, max) {
      this.donut.data[0].value = value;
      this.donut.data[1].value = max - value;
      this.donut.draw();
    }
  }
};
</script>

<style scoped lang="scss">
  .circle {
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }

  .plot {
    width: 100%;
    height: 100%;
  }
</style>
